module.exports = __webpack_public_path__ + "4c34688989644297ca449eb0ec2fd202.MP3";